/**
 *
 * AppGenerated
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import GlobalStyle from '../../global-styles';
import PublicViewEvent from 'containers/PublicViewEvent';
import isDOM from 'helpers/isDOM';

import PublicViewEventWrapperNotFound from 'containers/PublicViewEvent/styles/PublicViewEventWrapperNotFound';

function AppGenerated(props) {
  const thisEventData = props.eventData ? props.eventData : isDOM ? window.eventData : '';
  const templateSchema = thisEventData?.template?.templateSchema;

  if (!templateSchema) {
    return <PublicViewEventWrapperNotFound>{window.errorTextVar ? window.errorTextVar : '404 - Nothing here... :('} <br/><br/>Go back to <a href={'https://acara.io/'} rel={'noopener'} >Acara</a></PublicViewEventWrapperNotFound>;
  }

  return (
    <>
      <GlobalStyle />
      <StyleSheetManager  shouldForwardProp={isPropValid}>
        <PublicViewEvent eventData={props?.eventData}/>
      </StyleSheetManager>
    </>
  );
}



export default AppGenerated;
